import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ModalController } from "@ionic/angular";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { encryptUsingAES256, isMobile, UtilityService } from "@core/utility.service";
import { filter } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { ChatbotLiveChatPopComponent } from "../../components/chatbot-live-chat-pop/chatbot-live-chat-pop.component";
import { ToastService } from "@core/toast.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { MergeAccountPopupComponent } from "../../components/merge-account-popup/merge-account-popup.component";
import { PreferenceComponent } from "src/app/pages/account/edit-account/preference/preference.component";
import { TranslateService } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { Data } from "@angular/router";
//import { ModalController } from "@ionic/angular";

@Component({
    selector: "app-chatbot-test",
    templateUrl: "./chatbot-test.component.html",
    styleUrls: ["./chatbot-test.component.scss"],
    standalone: true,
})
export class ChatbotTestComponent implements OnInit {
  url: any;

  user$ = this.authService.userDetails$;
  chatBotUrl: any;
  translatedToastMsg: any;
  selectedLanguage: string = "en";

  constructor(
    private authService: AuthService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<ChatbotLiveChatPopComponent>,
    private toast: ToastService,
    private snackService: MySnackBarService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private GTMSegment: GTMSegmentService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
    this.user$.pipe(filter((f) => location.href?.search("helpTest") > -1))?.subscribe(
      async (u: Data) => {
        if (!u || !u.redirect) return;
        const minusOne = -1;
        if (u.redirect?.search("help") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/account/helpTest");
        } else if (u.redirect?.search("store") > -1) {
          this.router.navigateByUrl("/mainTabs/tabs/store");
        } else if (u.redirect?.search("voucher") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/voucher");
        } else if (u.redirect?.search("syndicate") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/syndicate");
        } else if (u.redirect?.search("account") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/account");
          // } else if (u.redirect?.search("game") > -1) {
          //   this.router.navigateByUrl("mainTabs/tabs/game");
        } else if (u.redirect?.search("profile&token") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/account/profile");
        } else if (u.redirect?.search("support&token") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/account/helpTest");
        } else if (u.redirect?.search("profile_payments&token") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/account/wallet");
        } else if (u.redirect?.search("registration&Prosub_ID") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/voucher");
        } else if (u.redirect?.search("voucher_redeem&token") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/voucher");
        } else if (u.redirect?.search("profile_password&token") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/account/profile");
        } else if (u.redirect?.search("payment&Prosub_ID") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/syndicate");
        } else if (u.redirect?.search("profile_preferences&token") > -1) {
          this.matDialog.open(PreferenceComponent, {
            height: "100%",
            width: "100%",
            panelClass: "modal-fullScreen",
            data: "chatbot",
          });
          dialogRef.afterClosed()?.subscribe(
            () => {
              this.router.navigateByUrl("mainTabs/tabs/account/helpTest");
            },
            (err) => {
              return err;
            }
          );
        } else if (u.redirect.search("game_center&gameId") > -1) {
          this.router.navigateByUrl("games/replayable/235");
        } else if (u.redirect?.search("game") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/game");
        } else if (u.redirect?.search("mgm") > minusOne) {
          this.router.navigateByUrl("refer-friends");
        }
        if (u.redirect.search("merge_accounts&token") > -1) {
          const modal = this.matDialog.open(MergeAccountPopupComponent, {
            height: "100%",
            width: "100%",
          });
          dialogRef.afterClosed()?.subscribe(
            () => {
              this.router.navigateByUrl("mainTabs/tabs/account/helpTest");
            },
            (err) => {
              return err;
            }
          );
        } else if (u.redirect.search("refer_a_friend&Prosub_ID") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/account");
        } else if (u.redirect.search("dashboard&token") > -1) {
          this.router.navigateByUrl("mainTabs/tabs/account");
        }
        if (u.redirect.search("live_chat") > -1 || u.redirect?.search("support&token") > -1) {
          /* const msg = this.translatedToastMsg?.["1066"]?.[this.selectedLanguage];
        this.authService.showToast(msg ? msg : "We are taking you to a live agent now.  Please wait", "success", ""); */
          this.GTMSegment.HotJarEvent("chat_escalated");
          this.authService.getConstantsMsg("1066").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "We are taking you to a live agent now. Please wait",
                  line_2: "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((error) => {
              return error;
            });
          setTimeout(() => {
            const modal = this.matDialog.open(ChatbotLiveChatPopComponent, {
              height: "100%",
              width: "100%",
            });
          }, 3000);
          dialogRef.afterClosed()?.subscribe(
            () => {
              this.router.navigateByUrl("mainTabs/tabs/account/helpTest");
            },
            (err) => {
              return err;
            }
          );
        }

        if (u.redirect != "") {
          this.authService.resetUserRedirect('');// This method is used to reset the user redirect node empty.
          this.dialogRef.close();
        }
        return;
      },
      (err) => {
        return err;
      }
    );
  }

  // GotoSyndicates() {
  //   this.dialogRef.close(true);
  // }

  ngOnInit() {
    const encryptedToken = encryptUsingAES256(localStorage.getItem("fbToken"));
    if (this.route.snapshot.queryParams?.bot_flow && this.route.snapshot.queryParams?.bot_flow != "")
      this.chatBotUrl = `https://web.lottosocial.com/chatbot?token=${encryptedToken}&bot_flow=${this.route.snapshot.queryParams?.bot_flow}&test=yes`;
    else this.chatBotUrl = `https://web.lottosocial.com/chatbot?token=${encryptedToken}&test=yes`;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.chatBotUrl);
  }
}
